import john from "../../assets/images/john.webp";
import { Link } from "react-router-dom";
import { motion } from "motion/react";
import Marquee from "react-fast-marquee";

type Service = {
  name: string;
};

const services: Service[] = [
  {
    name: "Risk Management & Compliance",
  },
  {
    name: "Strategic Financial Planning",
  },
  {
    name: "Mergers & Acquisitions",
  },
  {
    name: "Operational Cost Optimization",
  },
  {
    name: "Revenue Growth & Profitability Analysis",
  },
  {
    name: "Financial Forecasting & Budgeting",
  },
];

const HomeHeroSection = () => {
  const duplicatedItems = [
    ...services,
    ...services,
    ...services,
    ...services,
    ...services,
    ...services,
  ];
  return (
    <>
      <div className="lg:px-10 xl:px-20 relative max-w-screen-2xl mx-auto">
        <div className="bg-primary bg-opacity-5 lg:w-[50%] xl:w-[57%] px-11 py-8 sm:py-16 xl:pb-20 lg:rounded-tl-[36px] lg:rounded-tr-[36px]">
          <motion.h1
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="text-primary montserrat-bold text-4xl sm:text-6xl"
          >
            John Bostjancic:
          </motion.h1>
          <motion.h2
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            viewport={{ once: true }}
            className="montserrat-medium text-4xl lg:text-4xl xl:text-5xl mb-4 sm:mb-8"
          >
            Financial
            <span className="montserrat-bold text-primary"> Leadership</span> in
            the{" "}
            <span className="montserrat-bold text-primary">
              Medical Industry.
            </span>
          </motion.h2>
          <motion.p
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 1 }}
            viewport={{ once: true }}
            className="montserrat-regular mb-4 sm:mb-8"
          >
            Hey, I’m{" "}
            <span className="montserrat-semibold">John Bostjancic!</span> As a
            CFO, I specialize in shaping financial strategies, optimizing
            operations, and managing risks to drive growth and success in
            healthcare.
          </motion.p>
          <div className="flex flex-col sm:flex-row gap-5">
            <button
              onClick={() => {
                document
                  .getElementById("experience")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="py-3 px-10 bg-[#04004C] hover:bg-primary  border transition-all duration-300 rounded-full text-white"
            >
              My Experience
            </button>
            <Link to="/about-us">
              <button className="py-3 px-10 border-black border rounded-full hover:bg-primary hover:text-white transition-all duration-300">
                Learn More
              </button>
            </Link>
          </div>
        </div>
        <div className="hidden lg:block absolute w-[40%] xl:w-[37%] -top-[110px] right-20 h-full">
          <div className="relative w-full group">
            <svg
              width="493"
              height="732"
              viewBox="0 0 493 732"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[450px] xl:w-full object-cover"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M460 731C478.225 731 493 716.225 493 698V33C493 14.7746 478.225 0 460 0H256.126C243.771 0 231.806 5.57355 226.174 16.5709C216.864 34.7502 210.749 56.7824 204.877 77.939C202.288 87.2644 199.747 96.4197 197.001 105H44C19.6995 105 0 124.699 0 149V688C0 712.3 19.6994 732 44 732H340.96C344.175 732 347.311 731.655 350.33 731H460Z"
                fill="url(#paint0_linear_45_681)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_45_681"
                  x1="246.5"
                  y1="0"
                  x2="246.5"
                  y2="732"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#173F84" />
                  <stop offset="1" stopColor="#3060B3" />
                </linearGradient>
              </defs>
            </svg>

            <div className="size-[400px] bg-white p-14 rounded-full absolute top-40 left-16 bg-opacity-5 group-hover:scale-125 transition-all duration-300">
              <div className="size-full bg-white p-14 rounded-full bg-opacity-5 group-hover:scale-125 transition-all duration-300 delay-100">
                <div className="size-full bg-white rounded-full bg-opacity-5 group-hover:scale-125 transition-all duration-300 delay-200"></div>
              </div>
            </div>
            <motion.img
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
              src={john}
              alt="john"
              className="absolute z-30 bottom-0 xl:top-28 left-6 xl:left-10  xl:w-[85%] h-[70%] xl:object-contain"
            />

            <a
              href="/contact"
              className="bg-[#E9FF7A] py-3 px-7 absolute top-12 xl:top-10 right-0 xl:right-20 2xl:right-24 montserrat-medium rounded-full text-xl z-30 hover:bg-secondary hover:text-white transition-all duration-300"
            >
              Contact Me
            </a>
          </div>
        </div>
      </div>
      <div className="py-7 bg-primary relative  z-40">
        <div className="max-w-screen-2xl mx-auto px-5 lg:px-20 flex flex-col sm:flex-row gap-4 sm:gap-0 justify-between sm:justify-evenly montserrat-medium text-white overflow-hidden">
          <Marquee
            className="flex justify-center items-center"
            speed={50} // Speed of the scrolling
            gradient={false} // Disables the gradient at the edges
            pauseOnHover={true} // Pauses the scroll when hovered
            direction="left" // Scroll direction
          >
            {duplicatedItems.map((item, index) => (
              <div
                className="flex justify-center mx-6 flex-shrink-0"
                key={index}
              >
                <div className=" flex justify-center items-center mr-10">
                  <p>{item.name}</p>
                </div>
                <div className="border-b sm:border-r border-white sm:py-6"></div>
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </>
  );
};

export default HomeHeroSection;
